<template>
  <div class="clearfix cooperat_wrap">
    <div class="fl cooperat_left">
      <div class="cooperat_left_box">
        <div class="clearfix">
          <div class="fl c_white">
            <div class="fs20">商业合作</div>
            <div class="fs14 cooperat_left_text">COOPERATION</div>
          </div>
          <div class="fl cooperat_l_btn"></div>
        </div>
      </div>
    </div>
    <div class="fr cooperat_right">
      <!-- <div class="cooperat_r_box c_white flex">
        <div class="fs16">商业合作</div>

        <div
          class="fs24"
          style="margin: 4px 0 ;"
        >0755-36994096</div>
        <div
          class="fs14"
          style="opacity: 0.9;"
        >E-mail: marketing@witfort.net</div>
      </div> -->
      <!-- <img 
        src="@/image/index/icon_people.png"
        class="cooperat_r_img"
        alt=""
      > -->
      <div class="cooperat_r_box c_white ">
        <!-- <div class="fs16">商业合作</div> -->
        <div class="flex coop_nex" style="opacity: 0.9;">
          <div class="fs16 coop_li_nex"  v-for="(item,index) in info" :key="index">
            <span>{{item.title}}</span><br/><span>{{item.content}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: [
        {
          title: "【华南地区】",
          content: "陈经理:13560785646",
        },
        {
          title: "【华中地区】",
          content: "陈经理:18138449975",
        },
        {
          title: "【西南地区】",
          content: "李经理:18620120318",
        },
        {
          title: "【华东地区】",
          content: "杨经理:15817233407",
        }
      ],
    };
  },
};
</script>

<style lang="stylus" scoped>
@import './index.styl';
</style>


// WEBPACK FOOTER //
// src/components/cooperat/index.vue